
export class StrategyBaseClass {
  constructor($translate) {
    this.$translate = $translate;
  }

  getTaskTypesGroups() {
    return [
      {
        translateKey: this.getTypeString(),
        taskTypes: this.getAllTasksTypes()
      }
    ]
  }

  /*
   * For facebook, we removed event comments from the inbox list as the API doesn't allow us to retreive them anymore,
   * but the history must remain acccessible in the search and metric pages
   */
  getAllTasksTypesForSearchAndMetrics() {
    return this.getAllTasksTypes();
  }

  getAllTasksTypesForInbox() {
    return this.getAllTasksTypes();
  }

  taskTypeHasPublicationFilter(taskType) {
    return false;
  }

  taskTypeHasMentionFilter(taskType) {
    return false;
  }

  taskTypeHasPublicRepliesFilter(taskType) {
    return false;
  }

  externalInboxURL(site) {
    return null;
  }

  mustCheckIfMessageDeleted() {
    return false;
  }

  mustFetchContext(isPrivate) {
    return false;
  }

  handlesPublish() {
    return false;
  }

  getEditorConfiguration(isPrivate) {
    return {}; // use defaults: no picture, no user mentions, no bzc rich links, no max length
  }

  areAttachmentsAllowedWhenReplyingToPublicAsPrivate() {
    return true;
  }

  getSatisfactionSurveysExpirationHoursOptions() {
    return [0, 12, 23, 24, 36, 48, 60, 72, 84, 96, 240, 360];
  }

  getPrivateTaskTypes() {
    return [];
  }

  getMaxAllowedDaysToReplyToPrivateMsg() {
    return -1;  // Only fb messenger has a limit for now
  }

  getTaskTypeString(taskType) {
    return null;
  }

  taskTypeStringIsPrivate(taskType) {
    for (const type of this.getPrivateTaskTypes()) {
      if (this.getTaskTypeString(type) === taskType) {
        return true;
      }
    }
    return false;
  }

  taskTypeIsPrivate(taskType) {
    for (const type of this.getPrivateTaskTypes()) {
      if (type === taskType) {
        return true;
      }
    }
    return false;
  }

  getDefaultPrivateTaskType() {
    if (this.getPrivateTaskTypes().length > 0) {
      return this.getPrivateTaskTypes()[0];
    }
    return null;
  }

  getTaskTypesNotToTranslate() {
    return [];
  }

  canHaveSurveys() {
    return false;
  }
}
